import { createFileRoute } from '@tanstack/react-router';

// Route registration only. The component body lives in
// settings.alerts.lazy.tsx and code-splits via createLazyFileRoute.
// See Phase Bundle-Splitting-1 in DEVELOPMENT_ROADMAP.md.
export const Route = createFileRoute('/$locale/settings/alerts')({
  ssr: false,
});
